import * as index from './actions/index.action'

let actions = Object.assign({}, index)

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js